import { createContext, Dispatch, SetStateAction } from 'react'

export const HeaderSearchContext = createContext<{
  isShowSearch: boolean
  setIsShowSearch: Dispatch<SetStateAction<boolean>>
}>({
  isShowSearch: false,
  setIsShowSearch: () => null,
})
